(ns yardwerkz.web.profile.hub
  "Profile home page with links to sub-pages."
  (:require
   ["@clerk/clerk-react" :refer [useClerk]]
   [uix.core :refer [defui $]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(def menu-items
  [{:route :saved-addresses   :icon icons/Home          :label "Saved Addresses"        :desc "Manage your properties"}
   {:route :edit-profile      :icon icons/User           :label "Edit Profile"           :desc "Update your name and photo"}
   {:route :payment-methods   :icon icons/CreditCard     :label "Payment Methods"        :desc "Manage cards and payments"}
   {:route :payment-history   :icon icons/History        :label "Payment History"        :desc "View past transactions"}
   {:route :notification-prefs :icon icons/Bell          :label "Notification Preferences" :desc "Control your alerts"}])

(defui hub-page []
  (let [identity (rfx/use-sub [::store/identity])
        clerk (useClerk)]
    ($ layout/page-container
       ;; User header
       ($ :div {:class "flex items-center space-x-4 mb-8"}
          ($ :div {:class "h-16 w-16 rounded-full bg-green-100 flex items-center justify-center overflow-hidden"}
             (if (:image-url identity)
               ($ :img {:src (:image-url identity) :class "h-full w-full object-cover"})
               ($ icons/User {:size 32 :class "text-green-600"})))
          ($ :div
             ($ :h1 {:class "text-2xl font-bold text-gray-900"}
                (str (or (:first-name identity) "")
                     " "
                     (or (:last-name identity) "")))
             ($ :p {:class "text-sm text-gray-500"}
                (or (:email identity) (:phone identity) ""))))

       ;; Menu items
       ($ :div {:class "space-y-2"}
          (for [{:keys [route icon label desc]} menu-items]
            ($ ui/card {:key label
                        :class "p-4"
                        :on-click #(router/navigate! route)}
               ($ :div {:class "flex items-center justify-between"}
                  ($ :div {:class "flex items-center space-x-3"}
                     ($ :div {:class "p-2 rounded-lg bg-gray-100"}
                        ($ icon {:size 20 :class "text-gray-600"}))
                     ($ :div
                        ($ :p {:class "font-medium text-gray-900"} label)
                        ($ :p {:class "text-sm text-gray-500"} desc)))
                  ($ icons/ChevronRight {:size 20 :class "text-gray-400"})))))

       ;; Sign out
       ($ :div {:class "mt-8 pt-4 border-t border-gray-200"}
          ($ ui/button {:variant :ghost
                        :class "w-full text-red-600 hover:bg-red-50"
                        :on-click #(.signOut clerk)}
             ($ :span {:class "flex items-center justify-center space-x-2"}
                ($ icons/LogOut {:size 18})
                ($ :span "Sign Out")))))))
